import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Paper, Typography, Chip, Avatar } from '@mui/material';
import {
  PlayArrow as TriggerIcon,
  Task as TaskIcon,
  Schedule as ScheduleIcon,
  Webhook as WebhookIcon,
  Person as UserIcon
} from '@mui/icons-material';

const getIcon = (subtype) => {
  switch (subtype) {
    case 'task_created':
    case 'task_updated':
    case 'task_status_changed':
      return <TaskIcon fontSize="small" />;
    case 'task_assigned':
      return <UserIcon fontSize="small" />;
    case 'time_based':
      return <ScheduleIcon fontSize="small" />;
    case 'webhook':
      return <WebhookIcon fontSize="small" />;
    default:
      return <TriggerIcon fontSize="small" />;
  }
};

const TriggerNode = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: '12px 16px',
        borderRadius: 2,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : '#4caf50',
        backgroundColor: selected ? 'primary.light' : '#e8f5e9',
        minWidth: 180,
        transition: 'all 0.2s'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Avatar
          sx={{
            width: 28,
            height: 28,
            backgroundColor: '#4caf50',
            color: 'white'
          }}
        >
          {getIcon(data.config?.subtype)}
        </Avatar>
        <Typography variant="caption" sx={{ color: '#4caf50', fontWeight: 600 }}>
          TRIGGER
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
        {data.label || 'Trigger'}
      </Typography>
      
      {data.config?.description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {data.config.description}
        </Typography>
      )}
      
      {data.config?.subtype && (
        <Chip
          label={data.config.subtype.replace(/_/g, ' ')}
          size="small"
          sx={{ mt: 1, height: 20 }}
        />
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          background: '#4caf50',
          width: 10,
          height: 10
        }}
      />
    </Paper>
  );
};

export default memo(TriggerNode);